// extracted by mini-css-extract-plugin
export var hero = "vzKO_nxflajMRfEOvGQk";
export var root = "ikaEB1N0rwMa2FRtxwii";
export var title1 = "NjzgKvwGp88j37RaenEs";
export var title2 = "QV6G3j1aWqOy_Z1hQH60";
export var title3 = "QssL3ttUYSu1OxuuGHlw";